import { render, staticRenderFns } from "./Trainitem.vue?vue&type=template&id=2fd9a4e7&scoped=true"
import script from "./Trainitem.vue?vue&type=script&lang=js"
export * from "./Trainitem.vue?vue&type=script&lang=js"
import style0 from "./Trainitem.vue?vue&type=style&index=0&id=2fd9a4e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9a4e7",
  null
  
)

export default component.exports